import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import React, { useState } from 'react'
import DownloadIcon from 'SVGS/DownloadIcon';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import api from 'http';
import { toast } from 'react-toastify';
import validateEmail from 'Utils/ValidateEmail';
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader';
import ConfirmationPopup from 'Popups/ConfirmationPopup/ConfirmationPopup';

const ExportToEmail = ({ disabled, model, API, fileName, subHeading }) => {
    const [loader, setLoader] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const userEmail = useSelector((state) => state.userAuth.userinfo.userEmail);
    
    const handleExportToEmail = () => {
        if (!userEmail) {
            toast.error('Email address not found. Please ensure you are logged in.');
            return;
        }

        const emailValidation = validateEmail(userEmail);
        if (!emailValidation.isValid) {
            toast.error(emailValidation.message);
            return;
        }

        setShowConfirmation(true);
    }

    const handleConfirm = async () => {
        setShowConfirmation(false);
        setLoader(true);
        try {
            const requestPayload = {
                ...model, // keep all parent-level properties intact
                param_list: [
                    ...(model.param_list || []), // existing params
                    {
                        key: "ExportAndMailTo",
                        value: userEmail, // email from Redux
                    },
                ],
            };

            const response = await api.post(API, requestPayload);
            toast.success(response.data.responseMessage);
        } catch (error) {
            toast.error(error.response?.data?.responseMessage || 'Failed to export and send email');
        } finally {
            setLoader(false);
        }
    }

    const handleCancel = () => {
        setShowConfirmation(false);
    }

    return (
        <>
            {loader && <FullPageLoader allowFullScreen />}
            {showConfirmation && (
                <ConfirmationPopup
                    heading="Export to Email"
                    subHeading={
                        <span>
                           Are you sure you want to export and send the Excel sheet to <span className="font-semibold">{userEmail}</span>?
                        </span>
                    }
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                    buttonTitle="Send Email"
                    cancelButtonTitle="Cancel"
                />
            )}
            <CustomButtonNew
                label="Export to Email"
                disabled={disabled}
                variant="outline"
                color="secondary"
                onClick={handleExportToEmail}
                prefixIcon={<DownloadIcon />}
                className='h-fit'
            />
        </>
    )
}

export default ExportToEmail

ExportToEmail.propTypes = {
    disabled: PropTypes.bool,
    apiEndpoint: PropTypes.string.isRequired,
    payload: PropTypes.object,
    heading: PropTypes.string,
    description: PropTypes.string,
    onExport: PropTypes.func,
};
